import { computed, type ComputedRef } from 'vue';
import { isServer } from '@sitecore-jss/sitecore-jss/utils';
import type { ComponentRendering } from '@sitecore-jss/sitecore-jss/layout';
import { useJssStore } from '../stores/jssStore';

export function useRouteData(uid: string | undefined): {
  componentRouteIndex: ComputedRef<number | undefined>;
  componentItemIndex: ComputedRef<number | undefined>;
  topMainComponentData: ComponentRendering | undefined;
} {
  const jssStore = useJssStore();
  const jssMain = jssStore.routeData?.placeholders?.['jss-main'] as
    | ComponentRendering[]
    | undefined;
  const mainData = jssMain?.filter((c) => {
    if (!c.placeholders) return true;

    return Object.values(c.placeholders).some(
      (placeholderItems) =>
        Array.isArray(placeholderItems) &&
        placeholderItems.some((pi) => 'fields' in pi && !!pi.fields)
    );
  });
  const topMainComponentData = mainData?.[0];

  const componentName = computed(() => mainData?.find((c) => c?.uid === uid)?.componentName);
  const componentRouteIndex = computed(() =>
    !isServer() && globalThis?.IS_STORYBOOK ? 0 : mainData?.findIndex((c) => c.uid === uid)
  );
  const componentItemIndex = computed(
    () =>
      mainData
        ?.filter((c) => c.componentName === componentName?.value)
        .findIndex((c) => c.uid === uid)
  );

  return { componentRouteIndex, componentItemIndex, topMainComponentData };
}
